import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60c4d36f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 2,
  class: "ion-padding"
}

import { settings, people, home, enter } from "ionicons/icons";

import {
  IonContent,
  IonPage,
  IonTabButton,
  IonIcon,
  IonLabel,
  IonTabBar,
  IonTabs,
  IonRouterOutlet,
  onIonViewWillEnter,
  useIonRouter,
} from "@ionic/vue";
import { useRoute } from "vue-router";
import { useContextStore } from "@/stores/context";
import { useWindowWidth } from "@/composition/window";
import { reactive } from "vue";
import { useUserStore } from "@/stores/user";


export default /*#__PURE__*/_defineComponent({
  __name: 'Event',
  setup(__props) {

const userStore = useUserStore();
const router = useIonRouter();

const { isMobile } = useWindowWidth();
const contextStore = useContextStore();
const route = useRoute();
const event_id = parseInt(route.params.event_id as string, 10);

onIonViewWillEnter(async () => {
  userStore.fetchRoles().then(() => {
    const myEvents = userStore.related.events.map((event) => event.id);
    if (myEvents.includes(event_id)) {
      contextStore.getEvent(event_id);
    } else {
      router.push("/home");
    }
  });
});

const state = reactive({
  modalSettings: false,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          (_unref(contextStore).event.id && _unref(isMobile))
            ? (_openBlock(), _createBlock(_unref(IonTabs), { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonRouterOutlet)),
                  _createVNode(_unref(IonTabBar), {
                    slot: "bottom",
                    style: {"padding-top":"1rem"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonTabButton), {
                        tab: "home",
                        href: `/event/${_unref(event_id)}/home`
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonIcon), { icon: _unref(home) }, null, 8, ["icon"]),
                          _createVNode(_unref(IonLabel), null, {
                            default: _withCtx(() => [
                              _createTextVNode("Home")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["href"]),
                      _createVNode(_unref(IonTabButton), {
                        tab: "visitors",
                        href: `/event/${_unref(event_id)}/visitors`
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonIcon), { icon: _unref(people) }, null, 8, ["icon"]),
                          _createVNode(_unref(IonLabel), null, {
                            default: _withCtx(() => [
                              _createTextVNode("Visitors")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["href"]),
                      _createVNode(_unref(IonTabButton), {
                        tab: "scan",
                        href: `/event/${_unref(event_id)}/scan`
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonIcon), { icon: _unref(enter) }, null, 8, ["icon"]),
                          _createVNode(_unref(IonLabel), null, {
                            default: _withCtx(() => [
                              _createTextVNode("Check-in")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["href"]),
                      _createVNode(_unref(IonTabButton), {
                        tab: "settings",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (state.modalSettings = true)),
                        expand: "block",
                        href: `/event/${_unref(event_id)}/settings`
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonIcon), { icon: _unref(settings) }, null, 8, ["icon"]),
                          _createVNode(_unref(IonLabel), null, {
                            default: _withCtx(() => [
                              _createTextVNode("Setup")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["href"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : (_unref(contextStore).event.id && !_unref(isMobile))
              ? (_openBlock(), _createBlock(_unref(IonRouterOutlet), {
                  key: 1,
                  animated: false
                }))
              : (_openBlock(), _createElementBlock("p", _hoisted_1, "Loading..."))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})